import { useState } from 'react';
import SidebarLink from './SidebarLink';
import MobileNav from './MobileNav';


export default function Sidebar({user, handleLogout}) {
    const [isOpen, setIsOpen] = useState(false);

    const practiceManagementLink = 
        user?.role === 'super_admin' ? '/practice/clinics' : user?.role === 'admin' ? `/practice/clinics/${user.clinic_id}` : null;

    return (
        <>
            <MobileNav isOpen={isOpen} setIsOpen={setIsOpen} />
            {/* Sidebar Menu  */}
            <aside className={`fixed top-0 left-0 z-40 h-full w-64 bg-white/80 border-r border-slate-200 shadow-sm transform transition-transform duration-200 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0`} >
                <div className='flex flex-col h-full'>
                    <div className='p-4 border-b border-slate-200 flex items-center gap-3'>
                        <img src='/assets/invoco_logo_long_purple_transparentbg.webp' alt='invoco logo' className='w-36 mx-auto' />
                    </div>

                    {/* Nav links  */}
                    <nav className='flex-1 overflow-y-auto p-4 space-y-1'>
                        <SidebarLink to='/dashboard' label='dashboard' onClick={() => setIsOpen(false)} />
                        {user.role === 'super_admin' ? (
                            <SidebarLink to='/logs' label='logs' onClick={() => setIsOpen(false)} />   
                        ) : ''}

                        {practiceManagementLink && (
                            <SidebarLink to={practiceManagementLink} label='practice management' onClick={() => setIsOpen(false)} />
                        )}
                        
                    </nav>
                    {/* Footer/logout  */}
                    <div className='mt-auto border-t border-gray-700 pt-4 m-3'>
                        {user && (
                            <p className='text-sm mb-2 text-gray-600'>
                                logged in as <strong>{user.username}</strong>
                            </p>
                        )}
                        <button onClick={handleLogout} className='w-full border border-white/30 hover:bg-gray-300 bg-gray-200 transition-colors p-2 rounded-lg px-3 py-2  text-docpgrPurple font-semibold'>
                            logout
                        </button>
                    </div>
                </div>
            </aside>
        </>
    )
}